"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../../../utils");
exports.matchesValidator = {
    name: 'matches',
    validation: function (value, element, config) {
        if (!utils_1.isDefined(config.id) || !utils_1.isDefined(value)) {
            return true;
        }
        var el = document.getElementById(config.id);
        return el.value === value;
    },
};
//# sourceMappingURL=MatchesValidator.js.map